(function () {
  var ATTRIBUTE_RAW = '_ga_cookie';
  var ATTRIBUTE_CLIENT_ID = '_ga_client_id';
  var STORAGE_KEY = 'mansa_intima_ga_client_id_synced';

  function getCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i];
      var separator = part.indexOf('=');
      var key = separator >= 0 ? part.slice(0, separator) : part;
      if (key === name) {
        return decodeURIComponent(separator >= 0 ? part.slice(separator + 1) : '');
      }
    }
    return '';
  }

  function parseGaClientId(cookieValue) {
    var match = String(cookieValue || '').match(/^GA\d+\.\d+\.(.+)$/);
    return match ? match[1] : '';
  }

  function shouldSync(clientId) {
    try {
      return window.localStorage.getItem(STORAGE_KEY) !== clientId;
    } catch (error) {
      return true;
    }
  }

  function markSynced(clientId) {
    try {
      window.localStorage.setItem(STORAGE_KEY, clientId);
    } catch (error) {
      // Ignore browsers that block localStorage.
    }
  }

  function updateCartAttributes(gaCookie, clientId) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [ATTRIBUTE_RAW]: gaCookie,
          [ATTRIBUTE_CLIENT_ID]: clientId,
        },
      }),
      keepalive: true,
    });
  }

  function storeClientId(gaCookie, clientId) {
    if (!window.MansaIntimaGa4Capture || !window.MansaIntimaGa4Capture.endpoint) {
      return Promise.resolve();
    }

    return fetch(window.MansaIntimaGa4Capture.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        ga_cookie: gaCookie,
        client_id: clientId,
        page_location: window.location.href,
        page_referrer: document.referrer || '',
      }),
      keepalive: true,
    });
  }

  function syncGaClientId() {
    var gaCookie = getCookie('_ga');
    var clientId = parseGaClientId(gaCookie);

    if (!gaCookie || !clientId || !shouldSync(clientId)) {
      return;
    }

    Promise.allSettled([
      updateCartAttributes(gaCookie, clientId),
      storeClientId(gaCookie, clientId),
    ]).then(function () {
      markSynced(clientId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGaClientId, { once: true });
  } else {
    syncGaClientId();
  }
})();
